import { Outlet } from 'react-router';

export default function TestLayout() {
    return (
        <>
            <Outlet />
        </>
    );
}
